import { Box, Stack } from '@mui/material';
import { DialogWrapper } from '../common/dialogWrapper';
import { FsButton } from '../button';
import { useState } from 'react';
import { validatePassword } from '../../../services/authService';
import { FormikProvider, useFormik } from 'formik';
import { FormHelper } from '../../../helpers/formHelper';
import { TextWrapper } from '../formUtilities/useTextWrapper';
import ConfirmPasswordImage from '../../../assets/images/security.png';
import { InputWrapper } from '../formUtilities/useInput';
import { useTranslation } from 'react-i18next';

export const ConfirmPasswordDialog = ({ state, onClose = (e) => { } }) => {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const form = useFormik({
		initialValues: {
			password: '',
		},
		...FormHelper.formikProps(),
	});

	const onUpdatePassword = () => {
		setLoading(true);
		validatePassword(form.values)
			.then((resp) => {
				setLoading(false);
				onClose(true);
			})
			.catch((err) => {
				setLoading(false);
			});
	};

	return (
		<>
			<DialogWrapper
				maxWidth="xs"
				width={'330px'}
				state={state}
				onClose={() => {
					onClose(false);
				}}
				title={``}
				content={
					<Stack>
						<Box className="flex flex-col flex-0 items-center">
							<img
								className="w-28 mb-3 -mt-[7px]"
								src={ConfirmPasswordImage}
								alt="ConfirmPasswordImage"></img>
							<TextWrapper
								classList="!font-bold !text-xl !mb-3 !capitalize"
								text={t('passwordConfirm')}></TextWrapper>
						</Box>
						<Stack
							gap={2}
							className="text-center">
							<TextWrapper
								classList="!sub-title-text"
								text={t('enterCurrentPassword')}></TextWrapper>
							<form onSubmit={(e) => {
								e.preventDefault(); // Prevent default form submission
								if (!form.values.password) {
									return;
								}

								onUpdatePassword(); // Trigger your custom logic
							}}>
								<FormikProvider value={form}>
									<InputWrapper
										autoFocus
										type="password"
										key={'password'}
										name={'password'}
										label={t('password')}></InputWrapper>
								</FormikProvider>
							</form>
						</Stack>
					</Stack>
				}
				actions={
					<Box className="!w-full text-center">
						<FsButton
							loading={loading}
							disabled={!form.values.password}
							type="submit"
							onClick={() => {
								onUpdatePassword();
							}}>Confirm</FsButton>
					</Box>
				}></DialogWrapper>
		</>
	);
};
